import { createApp } from 'vue'
import { createPinia } from 'pinia'
import SuperTokens from 'supertokens-web-js'
import Session from 'supertokens-web-js/recipe/session'
import EmailPassword from 'supertokens-web-js/recipe/emailpassword'
import Passwordless from 'supertokens-web-js/recipe/passwordless'

import App from './App.vue'
import router, { setupRouter } from './router'
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'
import './style.css'
import urql, { client } from './plugins/urql'
import { initTheme } from './utils/theme'

// Initialize SuperTokens
SuperTokens.init({
  appInfo: {
    appName:
      (import.meta as any).env?.VITE_SUPERTOKENS_APP_NAME ||
      (import.meta as any).env?.VITE_APP_NAME ||
      'bost-auth',
    // Route auth via same domain (CloudFront will forward /auth/* to API GW)
    apiDomain: window.location.origin,
    apiBasePath: '/auth',
  },
  recipeList: [
    EmailPassword.init(),
    Passwordless.init(),
    Session.init({
      // Switch to cookie-based session for first-party cookies
      tokenTransferMethod: 'cookie',
    }),
  ],
})

// Apply saved theme (defaults to following system if none saved)
initTheme(true)

const app = createApp(App)
const pinia = createPinia()

// Configure toast options
const toastOptions = {
  timeout: 5000,
  position: 'top-right' as const,
  maxToasts: 5,
  newestOnTop: true,
}

// Initialize Pinia first
app.use(pinia)

// Initialize urql GraphQL client
app.use(urql, client)

// Setup router with navigation guards after Pinia is initialized
setupRouter(app).then(() => {
  app.use(router)
  app.use(Toast, toastOptions)
  app.mount('#app')
})
